import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { tokens } from "../theme";
import ProgressCircle from "./ProgressCircle";

const StatBox = ({ title, subtitle, icon, progress, increase }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNarrowScreen = useMediaQuery('(max-width:425px)');


  return (
    <Box width="100%" m="0 30px">
      <Box display={isNarrowScreen ? 'flex' : 'block'} justifyContent="space-between" mt="2px">
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{ color: colors.grey[100] }}
        >
          {title}
        </Typography>
        <Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>
          {subtitle}
        </Typography>
      </Box>
    </Box >
  );
};

export default StatBox;
